import { Component, OnInit, Input } from '@angular/core';

//importamos todas las librerias para sacar el excel
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-modal-dataset',
  templateUrl: './modal-dataset.page.html',
  styleUrls: ['./modal-dataset.page.scss'],
})
export class ModalDatasetPage implements OnInit {
    // Data passed in by componentProps
    @Input() dataset
    @Input() dataname: string;

    checklistsPreg3=[]
    excel=[]; //el array que se va a converir en excel

  constructor() { }

  ionViewWillEnter(){
   console.log(this.dataset);
  }

  ngOnInit() {
  }

//no hemos podido todavía sacar los checklists mas ejecutados
  // totalPreg3(entrada){
  //   let array=[]
  //   entrada.forEach((item)=>{
  //     item.forEach((item2,index)=>{
  //       // console.log("ESTAVAINA: "+item2.checklist.name)--hasta aqui OK
  //       this.checklistsPreg3.push(item2.checklist.name + "-")

  //     })
  //   })
  //  }



//exportar a excel

//la data que recibimos de la base de datos
arraydedatos=[
  {id:1, nombre:"pepi", apellido:"perez"},
  {id:2, nombre:"chipingo", apellido:"donoso"},
  {id:3, nombre:"kini", apellido:"Ramínera"},
  {id:4, nombre:"Wilson", apellido:"Pelotas"},
  {id:5, nombre:"Roberto", apellido:"Maquire"},
  {id:6, nombre:"Ramona", apellido:"Ricaurte"},
]

generaexcel(){
  this.excel=[]
  this.generarobjetodeexcel(()=>{//primero poblaomos el array excel[] con la data del array de datos en forma de objeto
    this.exportAsExcelFile(this.excel,'Reporte');//luego si generamos el excel. 'Reporte' es el nombre del archivo.
  })
}

//primero poblaomos el array excel[] con la data del array de datos en forma de objeto
generarobjetodeexcel(callback){
  this.excel=[];
  this.dataset.forEach((item)=>{

    if(this.dataname=='meetings'){
      this.excel.push({
        date: item.data().fecha,    
        prejob: item.data().pregunta1.pregunta,
        ptw: item.data().pregunta2.pregunta,
        nextDay: item.data().pregunta11.pregunta
      })
    }else
    if(this.dataname=='walkarounds'){
      this.excel.push({
        date: item.data().fecha,    
        leader1: item.data().pregunta4.pregunta,
        leader2: item.data().pregunta5.pregunta,
        leader3: item.data().pregunta6.pregunta
      })
    }
    else
    if(this.dataname=='safetycards'){
      this.excel.push({
        date: item.data().fecha,    
        safetyCards: item.data().pregunta7.pregunta,
      })
    }else
    if(this.dataname=='training'){
      this.excel.push({
        date: item.data().fecha,    
        trainings: item.data().pregunta13.pregunta,
        drills: item.data().pregunta14.pregunta,
        Drill1: item.data().pregunta14A.tema,
        Drill2: item.data().pregunta14B.tema,
        Drill3: item.data().pregunta14C.tema,
        Drill4: item.data().pregunta14D.tema,
      })
    }else
    if(this.dataname=='sop'){
      this.excel.push({
        date: item.data().fecha,    
        SOP: item.data().pregunta16.pregunta,
        GPS_findings: item.data().pregunta17.pregunta,
        ERP_updates: item.data().pregunta18.pregunta,
      })
    }else
    if(this.dataname=='checklists'){
      this.excel.push({
        date: item.data().fecha,    
        checklists_performed: item.data().pregunta3.length,
      })
    }else
    if(this.dataname=='accidents'){
      this.excel.push({
        date: item.data().fecha,    
        nearMisses: item.data().pregunta15Totales.totalNearMisses,
        fac: item.data().pregunta15Totales.totalFAC,
        cont_discharges: item.data().pregunta15Totales.totalDischarge
      })
    }




    
  })
  callback()
}


//aca se saca el excel
public exportAsExcelFile(json: any[], excelFileName: string): void {
const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
this.saveAsExcelFile(excelBuffer, excelFileName);
}
private saveAsExcelFile(buffer: any, fileName: string): void {
 const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
 FileSaver.saveAs(data, fileName + '_export_' + new  Date().getTime() + EXCEL_EXTENSION);
}




}
